<div class="header-background">
  <div class="container bgNav">
    <app-top-navigation></app-top-navigation>
  </div>
</div>
<app-breadcrumbs></app-breadcrumbs>
<div class="container">
  <div class="row">
    <div class="col-md-3">
      <app-side-menu></app-side-menu>
    </div>
    <div class="col-md-9 mt-4 mt-md-0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<app-footer></app-footer>